// extracted by mini-css-extract-plugin
export default {"wrap":"bG-z","fullWidth":"cG-z","hideOnDesktop":"dG-z","content":"eG-z","hasOpenedNav":"fG-z","crumbsList":"gG-z","dropdownsWrap":"hG-z"};